// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yI6XU","root":"styles_root__sGvw-"};